import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { chooseDepth } from '../../../data/snak';
import type { DepthChoice } from '../../../types/snak';
const EASE = [0.23, 1, 0.32, 1] as const;
interface ChooseDepthPageProps {
  onChoose: (choice: DepthChoice) => void;
}
export function ChooseDepthPage({
  onChoose
}: ChooseDepthPageProps) {
  return <div className="flex flex-1 flex-col px-10 py-8" data-id="element-88" data-mp="dcxb8ngulex0">
      <motion.h2 initial={{
      opacity: 0,
      y: 10
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.28,
      ease: EASE
    }} className="font-display text-[34px] font-semibold leading-[1.06] tracking-tight text-navy" data-id="element-89" data-mp="dbm6akbo214b">
        {chooseDepth.headline}
      </motion.h2>
      <p className="mt-3 text-[14px] leading-relaxed text-mut" data-id="element-90" data-mp="3vk392zzcpy5u">{chooseDepth.support}</p>

      <div className="mt-8 grid flex-1 gap-4 md:grid-cols-3" data-id="element-91" data-mp="2o5rr6ghd8yaw">
        {chooseDepth.options.map((opt, i) => <motion.button key={opt.id} type="button" onClick={() => onChoose(opt.id)} initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.26,
        delay: 0.08 + i * 0.06,
        ease: EASE
      }} className="group flex h-full flex-col rounded-2xl border border-line bg-paper px-6 py-6 text-left transition-colors duration-150 hover:border-navy hover:bg-navy focus:outline-none focus-visible:ring-2 focus-visible:ring-blue" data-id="element-92" data-mp="2k4y5zuvb5xlp" data-mpi={i}>
            <span className="font-display text-[11px] font-bold tabular-nums text-blue transition-colors duration-150 group-hover:text-mint" data-id="element-93" data-mp="1q3rndk9ustes">
              {String(i + 1).padStart(2, '0')}
            </span>
            <span className="mt-4 font-display text-[20px] font-semibold leading-snug text-navy transition-colors duration-150 group-hover:text-paper" data-id="element-94" data-mp="1gcon2kor0igk">
              {opt.label}
            </span>
            <span className="mt-2 text-[13px] leading-relaxed text-mut transition-colors duration-150 group-hover:text-sky/70" data-id="element-95" data-mp="17d1hrnswesi8">
              {opt.description}
            </span>
            <span className="mt-auto flex h-9 w-9 items-center justify-center rounded-full border border-line transition-colors duration-150 group-hover:border-mint/40 group-hover:bg-mint/20" data-id="element-96" data-mp="34bhab8uaa5rh">
              <ArrowRightIcon className="h-4 w-4 text-blue transition-colors duration-150 group-hover:text-mint" aria-hidden="true" data-id="element-97" data-mp="2vaj5wpfxnw8d" />
            </span>
          </motion.button>)}
      </div>
    </div>;
}